const mixpanel =
	require("mixpanel-browser").default ?? require("mixpanel-browser");

const {getFeatureFlag} = require("./FeatureFlags");

/**
 * This file contains the configuration for Mixpanel on the client, which we use for
 * tracking user events.
 * Nothing in this file will be active if enable-mixpanel-ba flag is disabled in launchdarkly.
 * https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript
 */

const isProduction = process.env.NODE_ENV === "production";
const prodProjectToken = "bc09bbd0948cece151490b637145edf2";
const devProjectToken = "1e283d07e000460bff6f1aa9a24de8a9";

let alreadyInit = false;

// mixpanel-browser assumes a browser environment; calling any of its methods
// during SSR (no window, or explicitly IS_NODE) throws since its internal
// state is never set up there.
const isBrowserEnv = function() {
	return typeof window !== "undefined" && !process.env.IS_NODE;
};

// session replay doesn't work on canvas elements
// so session replay inside the trainer isn't very valuable
// let's not waste a session replay on it
const stopSessionRecordingIfSchoolUrl = function() {
	if (!alreadyInit || typeof window === "undefined" || process.env.IS_NODE) {
		return;
	}
	if (!window.location.href.includes("/school")) {
		return;
	}
	if (typeof mixpanel.stop_session_recording === "function") {
		mixpanel.stop_session_recording();
	}
};

const init = function() {
	if (alreadyInit) return;
	if (typeof window === "undefined" || process.env.IS_NODE) return;

	const sessionReplayPercentage = Number(
		getFeatureFlag("CONTROL_MIXPANEL_SESSION_REPLAY")
	);

	mixpanel.init(isProduction ? prodProjectToken : devProjectToken, {
		debug: !isProduction,
		ignore_dnt: !isProduction,
		stop_utm_persistence: true,
		record_sessions_percent: sessionReplayPercentage,
		remote_settings_mode: "fallback", // remote settings are set from the UI and are purely additive to the sessionReplayPercentage
		autocapture: {
			pageview: "full-url",
			scroll: true,
			capture_text_content: false,
			click: false,
			dead_click: false,
			input: false,
			rage_click: false,
			submit: false,
		},
		// adding session replay caused mutex timeout error, increasing the flush frequency keeps the queue small
		batch_flush_interval: 2000,
		batch_size: 100,
	});
	mixpanel.register({
		app: "ba",
	});
	alreadyInit = true;
};

const setUser = function(user) {
	if (!isBrowserEnv()) {
		return;
	}
	if (!alreadyInit) {
		init();
	}
	if (!user) {
		return;
	}
	mixpanel.identify(user.platformUserID);
	mixpanel.people.set({
		$user_id: user.platformUserID,
		username: user.username,
		display_name: user.displayName,
		default_view: user.defaultView,
		ba_user_id: user.userID,
		platform_user_id: user.platformUserID,
	});
};

const reset = function() {
	if (!isBrowserEnv()) {
		return;
	}
	if (!alreadyInit) {
		init();
	}
	mixpanel.reset();
	mixpanel.register({
		app: "ba",
	});
};

const track = function(event, properties = {}) {
	if (!isBrowserEnv()) {
		return;
	}
	if (!alreadyInit) {
		init();
	}

	mixpanel.track(`BA ${event}`, {
		...properties,
	});
};

module.exports = {
	init,
	setUser,
	track,
	reset,
	stopSessionRecordingIfSchoolUrl,
};
